export default __webpack_public_path__ + "static/media/Nlogo1.17b68afe.png";